import React from 'react';
import { AccordionItemContent } from './AccordionItemContent.js';
import { AccordionRootProvider } from './AccordionRootProvider.js';
import { CollapsibleItem } from './CollapsibleItem.js';
import { AccordionWrapper, AccordionList } from './styles.js';
import { Divider } from '../../Dropdown/styles.js';

function Accordion({ items, isSideNavExpanded, onChange, startAnimations, isSideNavVisible, }) {
    return (React.createElement(AccordionRootProvider, null,
        React.createElement(AccordionWrapper, null,
            React.createElement(AccordionList, null, items.map((item) => {
                var _a;
                if (item.type === 'divider') {
                    return React.createElement(Divider, { key: item.order });
                }
                const hasChildren = Boolean((_a = item === null || item === void 0 ? void 0 : item.children) === null || _a === void 0 ? void 0 : _a.length);
                if (hasChildren) {
                    return (React.createElement(CollapsibleItem, { key: item.name, name: item.name, Icon: item.Icon, items: item.children, onChange: onChange, isSideNavExpanded: isSideNavExpanded, startAnimations: startAnimations, isSideNavVisible: isSideNavVisible }));
                }
                return (React.createElement(AccordionItemContent, { key: item.name, onClick: item === null || item === void 0 ? void 0 : item.onClick, Icon: item.Icon, name: item.name, href: item.url, badge: item.label, isSideNavExpanded: isSideNavExpanded, startAnimations: startAnimations, isSideNavVisible: isSideNavVisible }));
            })))));
}

export { Accordion };
